(() => {
  'use strict';

  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const text = (value) => String(value ?? '').trim();
  const normalize = (value) => text(value)
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/grey/g, 'gray')
    .replace(/[^a-z0-9]+/g, '');

  const imageUrl = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || value.url || value.preview_image?.src || '';
  };

  const fetchJson = async (url) => {
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Request failed (${response.status})`);
    return response.json();
  };

  async function resolveColorImage(group) {
    if (!group || group.dataset.meColorImageReady === 'true') return;
    group.dataset.meColorImageReady = 'true';

    const image = group.querySelector('[data-me-blank-group-image]');
    const color = text(group.dataset.meBlankColor);
    const title = text(group.dataset.meBlankProductTitle).replace(/\s*-\s*blank\s*$/i, '');
    const handle = text(group.dataset.meBlankProductHandle);
    if (!image || !color || color === 'Default') return;

    const colorKey = normalize(color);
    const currentKey = normalize(`${image.alt || ''} ${image.currentSrc || image.src || ''}`);
    if (currentKey.includes(colorKey)) return;

    try {
      const query = [title, color].filter(Boolean).join(' ');
      const suggestUrl = `${cartRoot()}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show`;
      const payload = await fetchJson(suggestUrl);
      const products = payload?.resources?.results?.products || [];
      const titleKey = normalize(title);

      const match = products.find((product) => {
        const candidateTitle = normalize(product.title);
        const candidateHandle = normalize(product.handle);
        const colorMatches = candidateTitle.endsWith(colorKey) || candidateHandle.endsWith(colorKey) || candidateTitle.includes(colorKey);
        const baseMatches = !titleKey || candidateTitle.includes(titleKey) || candidateHandle.includes(titleKey);
        return colorMatches && baseMatches;
      }) || products.find((product) => normalize(`${product.title} ${product.handle}`).includes(colorKey));

      if (!match) return;
      const productUrl = match.url || (match.handle ? `${cartRoot()}products/${match.handle}` : '');
      if (!productUrl) return;
      const productJson = await fetchJson(`${productUrl.replace(/\/$/, '')}.js`);
      const src = imageUrl(productJson.featured_image) || imageUrl(productJson.images?.[0]);
      if (!src) return;

      image.srcset = '';
      image.src = src;
      image.alt = `${color} ${title || 'blank apparel'}`;
    } catch (error) {
      console.warn('[Moments 9.7.10] Unable to resolve grouped blank color image', { color, handle, error });
    }
  }

  async function removeGroup(button) {
    const group = button.closest('[data-me-blank-cart-group]');
    if (!group || button.dataset.loading === 'true') return;
    const keys = (group.dataset.meBlankKeys || '').split('|').filter(Boolean);
    if (!keys.length) return;

    button.dataset.loading = 'true';
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'Removing…';

    try {
      const updates = Object.fromEntries(keys.map((key) => [key, 0]));
      const response = await fetch(`${cartRoot()}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Unable to remove the blank apparel group.');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      delete button.dataset.loading;
      button.textContent = original;
      window.alert(error.message || 'Unable to remove the blank apparel group.');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-me-blank-cart-group]').forEach(resolveColorImage);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-me-remove-blank-group]');
    if (!button) return;
    event.preventDefault();
    removeGroup(button);
  });
})();
